import React from "react";

import Products from "./products";
import News from "./news";
import Service from "./service";
import About from "./about";
import Contact from "./contact";

import "antd/es/divider/style/css";
import "antd/es/button/style/css";
import "antd/es/list/style/css";
import "antd/es/modal/style/css";
import "antd/es/cascader/style/css";

const components = {
  Products,
  News,
  Service,
  About,
  Contact,
};

class ContentIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <>
        {this.props.info.ROUTES.map((el) => {
          const Comp = components[el.COMPONENT];
          return <Comp key={el.COMPONENT} {...this.props} />;
        })}
      </>
    );
  }
}

export default ContentIn;
